import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-success-dialog-template',
  templateUrl: './success-dialog-template.component.html',
})
export class SuccessDialogTemplateComponent implements OnInit {

  get message() {
    return this.data.message || '';
  }

  constructor(
    public dialogRef: MatDialogRef<SuccessDialogTemplateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string }
  ) { }

  ngOnInit(): void {
  }

}
